/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PatchedWaterQualitySettings
 */
export interface PatchedWaterQualitySettings {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly simulationId?: number;
  /**
   * Size of the water quality timestep in seconds.
   */
  timeStep?: number;
  /**
   * Minimum size of the water quality timestep in seconds. Suitable default is 0.001. Cannot be greater than hydrodynamic minimum timestep.
   */
  minTimeStep?: number | null;
  /**
   * Maximum size of the water quality timestep in seconds. Cannot be greater than hydrodynamic maximum timestep.
   */
  maxTimeStep?: number | null;
  /**
   * The numerical threshold for the water quality simulation.
   */
  generalNumericalThreshold?: number;
  /**
   * The maximum number of steps used by the multi-step method.
   */
  maxNumberOfMultiStep?: number;
  /**
   * The maximum number of iterations used by the Gauss-Seidel sweep method.
   */
  maxGsSweepIterations?: number;
  /**
   * The convergence epsilon for the water quality simulation.
   */
  convergenceEps?: number;
}

/**
 * Check if a given object implements the PatchedWaterQualitySettings interface.
 */
export function instanceOfPatchedWaterQualitySettings(
  value: object
): value is PatchedWaterQualitySettings {
  return true;
}

export function PatchedWaterQualitySettingsFromJSON(json: any): PatchedWaterQualitySettings {
  return PatchedWaterQualitySettingsFromJSONTyped(json, false);
}

export function PatchedWaterQualitySettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedWaterQualitySettings {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    simulationId: json["simulation_id"] == null ? undefined : json["simulation_id"],
    timeStep: json["time_step"] == null ? undefined : json["time_step"],
    minTimeStep:
      json["min_time_step"] === undefined
        ? undefined
        : json["min_time_step"] === null
        ? null
        : json["min_time_step"],
    maxTimeStep:
      json["max_time_step"] === undefined
        ? undefined
        : json["max_time_step"] === null
        ? null
        : json["max_time_step"],
    generalNumericalThreshold:
      json["general_numerical_threshold"] == null ? undefined : json["general_numerical_threshold"],
    maxNumberOfMultiStep:
      json["max_number_of_multi_step"] == null ? undefined : json["max_number_of_multi_step"],
    maxGsSweepIterations:
      json["max_gs_sweep_iterations"] == null ? undefined : json["max_gs_sweep_iterations"],
    convergenceEps: json["convergence_eps"] == null ? undefined : json["convergence_eps"],
  };
}

export function PatchedWaterQualitySettingsToJSON(json: any): PatchedWaterQualitySettings {
  return PatchedWaterQualitySettingsToJSONTyped(json, false);
}

export function PatchedWaterQualitySettingsToJSONTyped(
  value?: Omit<PatchedWaterQualitySettings, "id" | "simulationId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    time_step: value["timeStep"],
    min_time_step: value["minTimeStep"],
    max_time_step: value["maxTimeStep"],
    general_numerical_threshold: value["generalNumericalThreshold"],
    max_number_of_multi_step: value["maxNumberOfMultiStep"],
    max_gs_sweep_iterations: value["maxGsSweepIterations"],
    convergence_eps: value["convergenceEps"],
  };
}
